export default {
  data() {
    return {
      url: '',
      title: '',
    }
  },
  computed: {
    // vkontakte() {
    //     return `https://vk.com/share.php?url=${window.location.href}`;
    // },
    // telegram() {
    //     const text = document.head.querySelector('title').innerHTML;
    //     return `https://t.me/share/url?url=${window.location.href}&text=${text}`;
    // },
    // facebook() {
    //     return `https://www.facebook.com/sharer.php?u=${window.location.href}`;
    // },
    // twitter() {
    //     const text = document.head.querySelector('title').innerHTML;
    //     return `https://twitter.com/intent/tweet?url=${window.location.href}&text=${text}&via=Axoft`;
    // },
    // ok() {
    //     const text = document.head.querySelector('title').innerHTML;
    //     return `https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&st.shareUrl=${window.location.href}&title=${text}`;
    // },
    // wa() {
    //     return `whatsapp://send?text=${window.location.href}`;
    // },
  },
  created() {
    this.url = window.location.href
    this.title = document.head.querySelector('title').innerHTML
  },
  methods: {},
}



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/share/component.js